import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZoneService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ZoneCreateDto,
  ZoneDto,
  ZoneExcelDownloadDto,
  ZoneUpdateDto,
} from '../proxy/planning/dtos/zone';
import { ZONE_CONFIG, ZONE_FIELDS } from './zone.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-zone',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, ZoneService, ConfirmationService],
  templateUrl: './zone.html',
  styleUrl: './zone.scss',
})
export class Zone extends BaseHierarchicalCrudComponent<
  ZoneDto,
  ZoneCreateDto,
  ZoneUpdateDto,
  ZoneExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(ZoneService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Zone', ids),
  };
  config = ZONE_CONFIG;
  fields = ZONE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ZoneDto): ZoneUpdateDto {
    return {
      name: data.name,
      code: data.code,
      locationId: data.locationId,
      subregionId: data.subregionId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Zone';
  }
}
